import {
  CORE_GET_IOT_INFO_REQUEST,
  CORE_GET_IOT_INFO_SUCCESS,

  CORE_LOAD_IOT_REQUEST,
  CORE_LOAD_IOT_SUCCESS,

  CORE_SEARCH_IOT_REQUEST,
  CORE_SEARCH_IOT_SUCCESS,

} from '../../types'

const initialState = []
export default {

  iots: (state = initialState, action) => {
    switch (action.type) {
      case CORE_LOAD_IOT_REQUEST:
      case CORE_SEARCH_IOT_REQUEST:
        return []
      case CORE_LOAD_IOT_SUCCESS:
      case CORE_SEARCH_IOT_SUCCESS:
        return action.payload

      default:
        return state
    }
  }
  ,
  iot: (state = initialState, action) => {
    switch (action.type) {
      case CORE_GET_IOT_INFO_REQUEST:
        return {}

      case CORE_GET_IOT_INFO_SUCCESS:
        return action.payload

      default:
        return state
    }
  }

}


// WEBPACK FOOTER //
// ./src/features/iot/reducer.js